import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import FeaturedVideos from "@/components/FeaturedVideos";
import Topics from "@/components/Topics";
import Manifesto from "@/components/Manifesto";
import Newsletter from "@/components/Newsletter";
import ComingSoon from "@/components/ComingSoon";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function Home() {
  const { hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const id = hash.replace("#", "");
      setTimeout(() => {
        document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
      }, 300);
    }
  }, [hash]);

  return (
    <main>
      <Hero />
      <Marquee />
      <FeaturedVideos />
      <Topics />
      <Manifesto />
      <Newsletter />
      <ComingSoon />
    </main>
  );
}
